import FormSelectField from "../../forms/fields/basic/SelectField";
import ConnectionFormDialog from "../../forms/ConnectionFormDialog";
import { SystemEntityCollections } from "../../../shared/enums/shared-enums";
import renderPersonSelection from "../../entitiesReferences/SelectionModals/PersonSelectionModal";
import {
  PERSON_CONNECTION_TYPE_LABELS,
  SystemPersonConnectionTypes,
  PersonConnection,
} from "../../../types/personConnection";
import { ConnectionFormDataController } from "../../../controllers/formController";
import { Person } from "../../../types/person";

interface PersonConnectionDialogProps {
  controller: ConnectionFormDataController<PersonConnection, Person, Person>;
}

const PersonConnectionDialog: React.FC<PersonConnectionDialogProps> = ({
  controller,
}) => {
  return (
    <ConnectionFormDialog<PersonConnection, Person, Person>
      fromLabel="Person"
      fromEntityCollection={SystemEntityCollections.PERSON}
      toLabel="Person"
      toEntityCollection={SystemEntityCollections.PERSON}
      renderFromEntitySelection={renderPersonSelection}
      renderToEntitySelection={renderPersonSelection}
      controller={controller}
    >
      <FormSelectField
        name="system_person_connection_type"
        placeholder="Select connection type"
        label="Connection Type"
        options={Object.values(SystemPersonConnectionTypes).map((item) => ({
          value: item,
          label: PERSON_CONNECTION_TYPE_LABELS[item],
        }))}
        required
      />
    </ConnectionFormDialog>
  );
};

export default PersonConnectionDialog;
